import { useUserMe } from "~/components/user/composables/useUser";

export const useActorFields = () => {
  const { authUser } = useUserMe();

  const requireAuthUserId = (): string => {
    if (!authUser.value?.id) {
      throw new Error("Erreur pour retrouver le profil utilisateur");
    }
    return authUser.value.id;
  };

  const actorFields = () => {
    const authUserId = requireAuthUserId();
    return {
      created_by: authUserId,
      updated_by: authUserId,
      updated_at: new Date().toISOString(),
    };
  };

  return {
    requireAuthUserId,
    actorFields,
  };
};
